<template>
  <div class="filter_legend_wrapper">

    <legend class="filter_legend">
      {{ legend }}
    </legend>
    <div class="filter_legend__clear" @click="clear" v-if="show">
      <v-icon size="20" class="x">fa-trash</v-icon>
      <!-- <span>Сбросить</span> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "filter_legend",
  data: () => ({}),
  props: {
    legend: { type: String },
    show: { type: Boolean },
  },
  methods: {
    clear(evt) {
      this.$emit("clear",evt);
    },
  },
};
</script>
<style lang="sass" scoped>
legend
  font-size: 14px
.filter_legend
  display: flex
  justify-content: space-between
  font-weight: 700
  &_wrapper
    display: grid
    grid-template-columns: 1fr 20px
  &__clear
    display: inline-flex
    align-items: center
    column-gap: 3px
    position: relative
    border-bottom: 1px solid transparent
    cursor: pointer
    font-weight: 400
    transition: all .3s linear
    span
      transition: all .3s linear
    span.x
      position: relative
      top: -1px
      font-size: 20px
      line-height: 20px
    &:hover
      // border-bottom: 1px solid var(--v-error-base)
      span, i
        color: var(--v-error-base)
</style>
